import {ValidationResult} from '../interfaces/validation-result';
import {i18n, I18nUtil} from '../utils/i18n-util';
import {Time} from '../interfaces/time';

export let timeValidationRules = {
  i18n: i18n,
  validateIsTime: function validateIsTime(input: string, condition: any, context: any): ValidationResult {
    let thisI18n = this.i18n;
    let result: ValidationResult = {
      isValid: thisI18n.isValidTime(input)
    };
    if (result.isValid) {
      context.parsedTime = thisI18n.deLocalizeTime(input);
    } else {
      result.errorMessage = this.i18n.getText(thisI18n.locale.DATETIME_FORMATS.shortTime === 'HH:mm' ? 'cu|validation engine|Must be a time (HH:MM)' : 'cu|validation engine|Must be a time (HH:MM AM or PM)');
    }
    return result;
  },
  validateMaxTime: function validateMaxTime(input: string, maxTime: Time, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: (<Time>context.parsedTime).getHours() * 60 + (<Time>context.parsedTime).getMinutes() <= maxTime.getHours() * 60 + maxTime.getMinutes()
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The time must be on or before xx', { maxTime: this.i18n.localizeTime(maxTime) });
    }
    return result;
  },
  validateMinTime: function validateMinTime(input: string, minTime: Time, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: (<Time>context.parsedTime).getHours() * 60 + (<Time>context.parsedTime).getMinutes() >= minTime.getHours() * 60 + minTime.getMinutes()
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The time must be on or after xx', { minTime: this.i18n.localizeTime(minTime) });
    }
    return result;
  }
};
